import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from 'src/app/_services/breadcrumbs.service';

@Component({
  selector: 'bxl-library',
  templateUrl: 'library.component.html',
})
export class LibraryComponent implements OnInit {
  initialized = false;
  constructor(private breadcrumbs: BreadcrumbsService) { }

  ngOnInit(): void {
    this.breadcrumbs.SetBreadcrumb('Library', '/library', []);
    this.initialized = true;
  }
}
